import React from 'react';
import { Spin, message } from 'antd';
import { gql, useMutation } from '@apollo/client';

import PasswordReset from '../../components/Login/PasswordReset';

const RESET_PASSWORD_QUERY = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input)
  }
`;

const AccountSettings = ({ onSuccess, onCancelClick }) => {
  const [resetPassword, { loading }] = useMutation(RESET_PASSWORD_QUERY);

  const onResetPasswordBtnClicked = (values) => {
    console.log('onResetPasswordBtnClicked called with ///', values);
    resetPassword({
      variables: {
        input: {
          current_password: values.current_password,
          new_password: values.new_password,
          new_password_confirm: values.new_password_confirm,
        },
      },
    })
      .then(({ data: { resetPassword } }) => {
        console.log('onResetPasswordBtnClicked done', resetPassword);
        if (resetPassword) {
          message.success('Password updated successfully!');
          onSuccess();
        }
      })
      .catch((e) => {
        console.log('mutationError ////', e, e.graphQLErrors);
        let error = '';
        if (e.graphQLErrors) {
          e.graphQLErrors.forEach(({ extensions, message }) => {
            const { category } = extensions;
            if (category === 'custom') {
              error = message;
            }
          });
        }
        message.error(
          error ? error : 'Some error occured, Please try again !!!'
        );
      });
  };

  return (
    <Spin spinning={false}>
      <PasswordReset
        onCancelClick={onCancelClick}
        onResetPasswordBtnClicked={onResetPasswordBtnClicked}
        loading={loading}
      />
    </Spin>
  );
};

export default AccountSettings;
